// extracted by mini-css-extract-plugin
export default {"map":"MapPage_map__y2YGE","logo":"MapPage_logo__qpv9c","balloon_content":"MapPage_balloon_content__5q4Kq","balloon_full_name":"MapPage_balloon_full_name__JPT10"};